import createClient from "openapi-fetch";
import {paths, SchemaTodoList} from "../listan-backend-api";
import {MouseEvent, useEffect, useMemo, useState} from "react";
import {ListsViewSettings, ListsViewSort} from "../ClientSidetypes";

const client = createClient<paths>();

export default function Lists(
    {
        shouldRefresh,
        navigateToList,
        listsViewSettings,
    } : {
        shouldRefresh: boolean,
        navigateToList: (listId: string) => void
        listsViewSettings: ListsViewSettings
    }) {

    const [seenLists, setSeenLists] = useState([{listId: "", itemCount: 0, listName: "", checkedItemCount: 0} as SchemaTodoList]);

    useEffect(() => {
        client.GET("/api/list")
            .then((response) => {
                if (response.response.ok && response.data) {
                    setSeenLists(response.data.lists);
                } else {
                    console.error(response);
                }
            })
            .catch(console.error);
    }, [shouldRefresh])

    const onLinkClick = (event: MouseEvent<HTMLAnchorElement>) => {
        // Check meta key and ctrl key so we don't stop a user who wants to open in a new tab.
        if (!event.metaKey && !event.ctrlKey) {
            console.log(event);
            event.preventDefault();
            const listId = event.currentTarget.getAttribute("data-listid");

            if (listId) {
                navigateToList(listId);
            }
        }
    };

    const sortByTimeStamp = (a : string, b : string) => {
        if (new Date(a) === new Date(b)) {
            return 0;
        }

        if (new Date(a) > new Date(b)) {
            return -1;
        } else {
            return 1;
        }
    }


    const sortedLists = useMemo(() => {

        let sorted = seenLists;
        for (let sortOrder of listsViewSettings.sortOrderHistory) {
            if (sortOrder.sortBy === ListsViewSort.CreatedAt) {
                sorted = sorted.slice().sort((a, b) => sortByTimeStamp(a.createdAt, b.createdAt));
            } else if (sortOrder.sortBy === ListsViewSort.ModifiedAt) {
                sorted = sorted.slice().sort((a, b) => sortByTimeStamp(a.modifiedAt, b.modifiedAt));
            } else if (sortOrder.sortBy === ListsViewSort.Name) {
                sorted = sorted.slice().sort((a, b) => a.listName.localeCompare(b.listName, "sv"));
            } else if (sortOrder.sortBy === ListsViewSort.Size) {
                sorted =  sorted.slice().sort((a, b) => b.itemCount - a.itemCount);
            } else if (sortOrder.sortBy === ListsViewSort.CheckedCount) {
                sorted = sorted.slice().sort((a, b) => b.checkedItemCount - a.checkedItemCount);
            } else {
                console.error("Unkown sort order: ", sortOrder.sortBy);
            }
        }

        return sorted;

    }, [listsViewSettings, seenLists]);

    return (
        <ul id={"lists"}>
            {
                sortedLists
                    .filter(seenList => !seenList.removed || listsViewSettings.showRemovedLists)
                    .map((seenList) => {
                    return (
                        <li key={seenList.listId} className={seenList.removed ? "removed" : ""}>
                            <a onClick={onLinkClick} data-listid={seenList.listId} href={"index.html?listid=" + seenList.listId}>
                                <span className={"listName"}>{seenList.listName}</span>
                                <span className={"itemCount"}>{seenList.checkedItemCount}/{seenList.itemCount}</span>
                                <span className={"createdAt"}>{seenList.createdAt}</span>
                                <span className={"modifiedAt"}>{seenList.modifiedAt}</span>
                            </a>
                        </li>
                    );
                })
            }
        </ul>
    );
}